import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home as HomeIcon, ArrowRight } from "lucide-react";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/shared/SEO";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#FAFAF9] flex flex-col" data-testid="not-found-page">
      <SEO title="Page not found — Ever Clean Home" description="The page you're looking for doesn't exist." noindex />
      <Header />
      <div className="flex-1 grid place-items-center px-4 py-16">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="text-center max-w-md">
          <div className="font-mono text-7xl font-bold text-[#0EA5A4]">404</div>
          <h1 className="mt-4 font-display text-3xl md:text-4xl font-extrabold tracking-tighter">Page not found</h1>
          <p className="mt-3 text-[#4B5563]">
            The page you're looking for doesn't exist — maybe it was moved, or maybe it never existed.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/"><Button className="rounded-xl bg-[#0EA5A4] hover:bg-[#0F766E] text-white" data-testid="404-home"><HomeIcon className="w-4 h-4 mr-2" /> Back home</Button></Link>
            <Link to="/book"><Button variant="outline" className="rounded-xl" data-testid="404-book">Book a cleaning <ArrowRight className="w-4 h-4 ml-2" /></Button></Link>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}
